define('debug',[],function() {	
	$('.grid-toggler').click(function(e){
		var element = document.getElementById("page");
	   	if (!element.style.backgroundImage || element.style.backgroundImage == "none") {
	   		element.style.backgroundImage = "url('/img/design_elements/1000_12_20.png')";
	   	} else {
	   		element.style.backgroundImage = "none";
	   	}
	});

    $('.vertical-lines-toggler').click(function(e) {
        var element = document.getElementById("content");
        element.style.backgroundPosition = "0 1px";
        if (!element.style.backgroundImage || element.style.backgroundImage == "none") {
            element.style.backgroundImage = "url('http://basehold.it/i/20')";
        } else {
            element.style.backgroundImage = "none";
        }
    });
});
